<template>
  <c-row>
    <c-col col="12">
      <loader v-show="loading" />
      <c-card>
        <loader v-show="loading" />
        <c-card-body>
          <div class="form-group form-row">
            <label class="col-form-label col-md-1">Filter</label>
            <div class="form-group col-md-3">
              <datetime
                class="date-control"
                v-model="filter.date"
                @input="changeFilterDate"
              />
            </div>
            <div class="form-group col-md-8">
              <input
                type="text"
                class="form-control"
                placeholder="ketikkan untuk mencari"
                v-model="keyword"
                @keyup="search"
              />
            </div>
          </div>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Product</th>
                  <th>ETA</th>
                  <th>ETD</th>
                  <th>Route</th>
                  <th>Faktur</th>
                  <th>Qty</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data.data" :key="k">
                  <td align="center" width="35">
                    <table-number
                      :page="paginate.page"
                      :size="paginate.per_page"
                      :index="k"
                    />
                  </td>
                  <td>{{ d.name }}</td>
                  <td>{{ d.eta | dateFormat }}</td>
                  <td>{{ d.etd | dateFormat }}</td>
                  <td>{{ d.route }}</td>
                  <td>{{ d.faktur }}</td>
                  <td>{{ d.qty }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <export-excel
            class="float-left"
            url="/api/v1/export/excel/intransit-goods"
          />
          <CPagination
            align="end"
            :active-page.sync="currentPage"
            :pages="Math.ceil(paginate.total / paginate.per_page)"
            responsive
          />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
// import { RotateSquare2 } from "vue-loading-spinner";
import TableNumber from "../../components/TableNumber";
import Loader from '../../components/Loader.vue';
import ExportExcel from '../../components/ExportExcel.vue';
export default {
  components: {
    // RotateSquare2,
    TableNumber,
    Loader,
    ExportExcel,
  },
  data () {
    return {
      loading: true,
      data: {},
      paginate: {},
      currentPage: 1,
      filter: {
        date: moment().format(),
      },
      keyword: '',
    };
  },
  created () {
    this.getList(1);
  },
  methods: {
    getList (page) {
      this.loading = true;
      HTTPAUTH.get(`/api/v1/po/logbook?size=10&page=${page}&q=${this.keyword}&date=${this.filter.date}`)
        .then((res) => {
          this.data = res.data;
          this.paginate = res.data.paginate;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changeFilterDate (date) {
      console.log(date);
    },
    search (e) {
      if (e.keyCode == 13) {
        this.getList(1)
      }
    }
  },
  watch: {},
};
</script>